module.exports = __webpack_public_path__ + "d2c21946524d38df018234c8bc96afc4.svg";